import { db } from "./db";

/**
 * Cache the authenticated user's identity in IndexedDB for offline use.
 *
 * Called when the user is authenticated so their identity is available if the
 * app goes offline before the next session.
 */
export async function cacheUser({
  userId,
  email,
  name,
}: {
  userId: string;
  email: string;
  name: string;
}): Promise<void> {
  await db.cachedUser.put({
    id: "cachedUser",
    userId,
    email,
    name,
    cachedAt: new Date(),
  });
}

/**
 * Remove the cached user identity.
 *
 * Called when the user is online but not authenticated, so stale cached
 * credentials are not used on the next offline session.
 */
export async function clearCachedUser(): Promise<void> {
  await db.cachedUser.delete("cachedUser");
}
